export default __webpack_public_path__ + "static/media/settings.d4048085.svg";